@if (visible()) {
  <div class="relative z-1000" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"></div>
    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10">
              <vti-icons [icon]="'question'" color="yellow" colorTint="400" size="7"></vti-icons>
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">{{ title() }}</h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">
                  {{ content() }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:items-center sm:flex-row-reverse gap-x-4">
            <vti-button [text]="okText()" (onClick)="onOkClick()"></vti-button>
            <vti-button [text]="cancelText()" (onClick)="onCancelClick()" ghost></vti-button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
